export default function Orders(){
    return (
        <div>
            <h2>Total orders</h2>
        </div>
    )
}